interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/28ce903ceaaf15cb653f91e3ac9d0a25.jpeg" 
              alt="Cobramas Production Logo" 
              className="h-14 w-auto"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-400'
              }`}
            >
              Beranda
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-400'
              }`}
            >
              Tentang Kami
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-400'
              }`}
            >
              Produk
            </button>
            <button 
              onClick={() => scrollToSection('advantages')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-400'
              }`}
            >
              Keunggulan
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-400'
              }`}
            >
              Galeri
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-400'
              }`}
            >
              Kontak
            </button>
            <a 
              href="https://wa.me/6285642080427"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-orange-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-700 transition-colors whitespace-nowrap"
            >
              Hubungi Kami
            </a>
          </div>

          <button className="md:hidden text-gray-700">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}